import React, { useState } from 'react'
import { Menu, X } from 'lucide-react'
import headerLogo from '../assets/images/headerLogo.png'

export const Navbar = () => {
  const [navOpen, setNavOpen] = useState(false)

  const navItems = [
    { name: 'Hjem', href: '#hjem' },
    { name: 'Om oss', href: '#om-oss' },
    { name: 'Salgsarenaer', href: '#salgsarenaer' },
    { name: 'Arrangementer', href: '#arrangementer' },
    { name: 'Kontakt', href: '#kontakt' },
  ]

  return (
    <nav className="w-full fixed top-0 left-0 bg-white shadow z-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-3 flex justify-between items-center">
        {/* Logo */}
        <div className="flex items-center">
          <a href="#hjem" className="flex items-center gap-2">
            <img src={headerLogo} alt="logo" className="h-20 w-auto" />
          </a>
        </div>

        {/* Desktop Nav */}
        <ul className="hidden md:flex space-x-6 text-sm font-medium text-gray-800">
          {navItems.map((item) => (
            <li key={item.name}>
              <a
                href={item.href}
                className="p-2 hover:text-[#FD517B] cursor-pointer"
              >
                {item.name}
              </a>
            </li>
          ))}
        </ul>

        {/* Book Button (Desktop) */}
        <div className="hidden md:block">
        <a
  href="#book"
  className="border border-[#FD517B] hover:bg-[#FD517B] hover:text-gray-800 text-gray-800 px-8 py-2 rounded-md text-sm font-medium"
>
  Book en tur!
</a>
        </div>

        {/* Mobile Menu Toggle */}
        <div className="md:hidden">
          <button onClick={() => setNavOpen(!navOpen)}>
            {navOpen ? (
              <X className="w-6 h-6 text-[#FD517B]" />
            ) : (
              <Menu className="w-6 h-6 text-[#FD517B]" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Nav Dropdown */}
      {navOpen && (
        <div className="md:hidden bg-white px-6 py-4 shadow-md space-y-4">
          <ul className="space-y-2 text-gray-800 font-medium">
            {navItems.map((item) => (
              <li key={item.name}>
                <a
                  href={item.href}
                  onClick={() => setNavOpen(false)}
                  className="hover:text-[#FD517B] block"
                >
                  {item.name}
                </a>
              </li>
            ))}
          </ul>
          <a
  href="#book"
  onClick={() => setNavOpen(false)}
  className="bg-[#FD517B] w-full text-white py-2 rounded-full text-sm hover:bg-[#e8466e] transition text-center block"
>
  Book en tur!
</a>
        </div>
      )}
    </nav>
  )
}
